import styled, { css } from 'styled-components/macro';
import { Heading, tokens, utils } from '@snsw/react-component-library';
const { pxToRem, getSpacing, marginMixin } = utils;
const { font } = tokens;

export const FormFieldset = styled.fieldset`
  position: relative;
  border: 0;
  padding: 0;
  border-radius: 0;
  ${marginMixin}

  > .field-item:first-of-type,
  .date-container {
    margin-top: ${getSpacing(['xs'])};
  }

  .radio-item:first-of-type,
  .checkbox-item:first-of-type {
    margin-top: ${getSpacing(['sm'])};
  }

  ${(props) =>
    props.smallLegend &&
    css`
      legend h3 {
        font-size: ${pxToRem(font.size.base)};
        font-weight: ${font.weight.medium};
      }
      label {
        font-weight: ${font.weight.book};
      }
    `}
`;

export const FormLegend = styled.legend`
  padding: 0;
`;

export const FormLegendLabel = styled(Heading).attrs({ level: 4 })`
  margin: 0;
`;

// TODO: Move in to own file
export const SROnly = styled.span`
  border: 0 !important;
  clip: rect(1px, 1px, 1px, 1px) !important;
  -webkit-clip-path: inset(50%) !important;
  clip-path: inset(50%) !important;
  height: 1px !important;
  overflow: hidden !important;
  padding: 0 !important;
  position: absolute !important;
  width: 1px !important;
  white-space: nowrap !important;
`;
